/*
 * Barrierefreie Tooltips für .js-tooltip
 *
 * Ersetzt "jquery-accessible-simple-tooltip-aria" v2.2.0 (Nicolas Hoffmann, MIT).
 * Ziel: WCAG 2.2 AA – insbesondere
 *   1.4.13 Content on Hover or Focus (Dismissible / Hoverable / Persistent)
 *   2.1.1 Keyboard und 1.1.1 Non-text Content (Textalternative liegt im DOM,
 *         nicht nur im visuellen Tooltip)
 *   1.4.10 Reflow (Tooltip wird in den Viewport geschoben bzw. nach unten geklappt)
 *   4.1.2 Name, Role, Value (kein aria-describedby auf aria-hidden-Triggern)
 *
 * Öffentliche API bleibt unverändert:
 *   Trigger:      .js-tooltip
 *   Inhalt:       data-simpletooltip-text | data-simpletooltip-content-id
 *   Klassen-Präfix: data-simpletooltip-prefix-class
 *   Init:         accessibleSimpleTooltipAria.apply(element) oder $(sel).accessibleSimpleTooltipAria()
 */
(function($) {
    'use strict';

    // Verzögerung beim Schließen, damit der Zeiger vom Trigger auf den Tooltip wandern kann
    var HIDE_DELAY = 150;
    // Mindestabstand zum Viewport-Rand
    var VIEWPORT_PADDING = 8;
    // Abstand zwischen Trigger und Tooltip (wird von der Hover-Brücke überbrückt)
    var TRIGGER_GAP = 8;

    var openInstances = [];
    var documentHandlersBound = false;

    // Whitespace vereinheitlichen und kleinschreiben, für Textvergleiche
    function normalize(text) {
        return $.trim(String(text || '').replace(/\s+/g, ' ')).toLowerCase();
    }

    // Reinen Text aus einem HTML-Schnipsel holen
    function htmlToText(html) {
        return $('<div></div>').html(html).text();
    }

    function isFocusable($element) {
        return $element.is('a[href], button, input, select, textarea, [tabindex], [contenteditable="true"]');
    }

    // Eine ID aus aria-describedby entfernen; leeres Attribut wird gelöscht
    function removeDescribedbyRef($trigger, id) {
        var current = $trigger.attr('aria-describedby');
        if (!current || !id) {
            return;
        }
        var remaining = $.grep(current.split(/\s+/), function(value) {
            return value !== '' && value !== id;
        });
        if (remaining.length) {
            $trigger.attr('aria-describedby', remaining.join(' '));
        } else {
            $trigger.removeAttr('aria-describedby');
        }
    }

    /* Tooltip-Instanz -------------------------------------------------- */

    function TooltipInstance($trigger, $tooltip, exposed) {
        this.$trigger = $trigger;
        this.$tooltip = $tooltip;
        this.exposed = exposed;
        this.hideTimer = null;
        this.visible = false;
    }

    TooltipInstance.prototype.show = function() {
        this.cancelHide();
        if (this.visible) {
            this.position();
            return;
        }
        this.visible = true;
        this.$tooltip.addClass('is-visible');
        if (this.exposed) {
            this.$tooltip.attr('aria-hidden', 'false');
        }
        openInstances.push(this);
        this.position();
    };

    TooltipInstance.prototype.hide = function() {
        this.cancelHide();
        if (!this.visible) {
            return;
        }
        this.visible = false;
        this.$tooltip.removeClass('is-visible simpletooltip--below');
        if (this.exposed) {
            this.$tooltip.attr('aria-hidden', 'true');
        }
        var index = $.inArray(this, openInstances);
        if (index !== -1) {
            openInstances.splice(index, 1);
        }
    };

    TooltipInstance.prototype.toggle = function() {
        if (this.visible) {
            this.hide();
        } else {
            this.show();
        }
    };

    TooltipInstance.prototype.scheduleHide = function() {
        var instance = this;
        this.cancelHide();
        this.hideTimer = window.setTimeout(function() {
            instance.hide();
        }, HIDE_DELAY);
    };

    TooltipInstance.prototype.cancelHide = function() {
        if (this.hideTimer) {
            window.clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
    };

    // Der Tooltip liegt als position:fixed-Layer am <body> und wird anhand des
    // Trigger-Rechtecks platziert. Dadurch kann ihn kein overflow:hidden eines
    // Vorfahren abschneiden und kein fremder Bezugsrahmen verschieben.
    TooltipInstance.prototype.position = function() {
        var element = this.$tooltip[0];

        this.$tooltip.removeClass('simpletooltip--below');
        element.style.left = '0px';
        element.style.top = '0px';

        var triggerRect = this.$trigger[0].getBoundingClientRect();
        var tooltipRect = element.getBoundingClientRect();
        var viewportWidth = document.documentElement.clientWidth;
        var centerX = triggerRect.left + (triggerRect.width / 2);

        // Horizontal zentrieren und in den Viewport klemmen (1.4.10 Reflow)
        var left = centerX - (tooltipRect.width / 2);
        var maxLeft = viewportWidth - VIEWPORT_PADDING - tooltipRect.width;
        if (left > maxLeft) {
            left = maxLeft;
        }
        if (left < VIEWPORT_PADDING) {
            left = VIEWPORT_PADDING;
        }

        // Oberhalb des Triggers, falls dort Platz ist – sonst darunter
        var top = triggerRect.top - tooltipRect.height - TRIGGER_GAP;
        if (top < VIEWPORT_PADDING) {
            top = triggerRect.bottom + TRIGGER_GAP;
            this.$tooltip.addClass('simpletooltip--below');
        }

        // Pfeil bleibt auf den Trigger gerichtet, auch wenn der Tooltip geklemmt wurde
        var arrowX = Math.max(10, Math.min(tooltipRect.width - 10, centerX - left));
        element.style.setProperty('--simpletooltip-arrow-x', Math.round(arrowX) + 'px');
        element.style.left = Math.round(left) + 'px';
        element.style.top = Math.round(top) + 'px';
    };

    /* Globale Handler --------------------------------------------------- */

    function hideAll() {
        $.each(openInstances.slice(), function(index, instance) {
            instance.hide();
        });
    }

    function repositionAll() {
        if (!openInstances.length) {
            return;
        }
        $.each(openInstances.slice(), function(index, instance) {
            instance.position();
        });
    }

    function hideAllExcept(target) {
        $.each(openInstances.slice(), function(index, instance) {
            if (!instance.$trigger[0].contains(target) && !instance.$tooltip[0].contains(target)) {
                instance.hide();
            }
        });
    }

    function bindDocumentHandlers() {
        if (documentHandlersBound) {
            return;
        }
        documentHandlersBound = true;

        $(document)
            // Esc schließt jeden offenen Tooltip, unabhängig von Maus- oder Fokusposition (1.4.13 Dismissible)
            .on('keydown.simpletooltip', function(event) {
                if (!openInstances.length) {
                    return;
                }
                if (event.key === 'Escape' || event.key === 'Esc' || event.which === 27) {
                    hideAll();
                }
            })
            // Tap/Klick außerhalb schließt offene Tooltips
            .on('click.simpletooltip touchstart.simpletooltip', function(event) {
                if (openInstances.length) {
                    hideAllExcept(event.target);
                }
            });

        $(window).on('resize.simpletooltip orientationchange.simpletooltip', repositionAll);

        // Capture-Phase, damit auch das Scrollen in Containern erfasst wird
        document.addEventListener('scroll', repositionAll, true);
    }

    /* Initialisierung ---------------------------------------------------- */

    // Stellt sicher, dass der Tooltip-Text auch ohne Maus/Hover im Accessibility-Tree steht
    function ensureTextAlternative($trigger, contentText, triggerText, triggerHidden, $source) {
        var needle = normalize(contentText);
        if (!needle) {
            return;
        }
        // Text steht bereits im Trigger (z.B. eigenes .sr-only-Kind)
        if (!triggerHidden && triggerText.indexOf(needle) !== -1) {
            return;
        }
        // content-id verweist auf ein Element, das ohnehin im DOM liegt
        if ($source && $source.length) {
            return;
        }
        // Geschwisterelemente prüfen (typisch: <span class="sr-only">)
        var siblingsText = normalize($trigger.siblings().not('.js-simpletooltip').text());
        if (siblingsText.indexOf(needle) !== -1) {
            return;
        }

        var $alternative = $('<span class="sr-only"></span>').text(contentText);
        // Innerhalb eines aria-hidden-Triggers wäre der Text für AT unsichtbar,
        // und leere Elemente (img, input …) können gar keine Kinder aufnehmen.
        if (triggerHidden || $trigger.is('img, input, area, embed, br, hr, source, track, wbr')) {
            $alternative.insertAfter($trigger);
        } else {
            $trigger.append($alternative);
        }
    }

    function initTooltip(element) {
        var $trigger = $(element);

        if (!$trigger.length || $trigger.data('simpletooltipInitialized')) {
            return;
        }

        var options = $trigger.data();
        var prefix = typeof options.simpletooltipPrefixClass !== 'undefined' ? options.simpletooltipPrefixClass + '-' : '';

        // Inhalt bestimmen
        var contentHtml = '';
        var $source = null;
        if (typeof options.simpletooltipText !== 'undefined' && options.simpletooltipText !== '') {
            contentHtml = String(options.simpletooltipText);
        } else if (options.simpletooltipContentId) {
            $source = $(document.getElementById(options.simpletooltipContentId));
            if ($source.length) {
                contentHtml = $source.html();
            }
        }

        var contentText = htmlToText(contentHtml);
        if (!$.trim(contentText)) {
            return;
        }

        // Text des Triggers ohne einen eventuell schon vorhandenen Tooltip
        var $triggerClone = $trigger.clone();
        $triggerClone.find('.js-simpletooltip').remove();
        var triggerText = normalize($triggerClone.text() + ' ' + ($trigger.attr('aria-label') || '') + ' ' + ($trigger.attr('alt') || ''));
        var triggerHidden = $trigger.attr('aria-hidden') === 'true';
        var focusable = isFocusable($trigger);

        // Statisch im Template ausgeliefertes Tooltip-Markup wiederverwenden statt zu duplizieren
        var $tooltip = $trigger.next('.js-simpletooltip');
        if (!$tooltip.length) {
            $tooltip = $trigger.children('.js-simpletooltip').last();
        }
        if (!$tooltip.length) {
            $tooltip = $('<span></span>').html(contentHtml);
        }
        $tooltip
            .addClass('js-simpletooltip ' + prefix + 'simpletooltip')
            .removeClass('is-visible simpletooltip--below hover')
            .attr('role', 'tooltip')
            .attr('aria-hidden', 'true');

        // Der Tooltip wird nur dann für AT verlinkt, wenn der Trigger fokussierbar ist
        // und den Text nicht ohnehin schon im Accessible Name trägt.
        var exposed = focusable && !triggerHidden && triggerText.indexOf(normalize(contentText)) === -1;

        if (exposed) {
            var tooltipId = $tooltip.attr('id') || 'label_simpletooltip_' + Math.random().toString(32).slice(2, 12);
            $tooltip.attr('id', tooltipId);
            removeDescribedbyRef($trigger, tooltipId);
            var describedby = $.trim(tooltipId + ' ' + ($trigger.attr('aria-describedby') || ''));
            $trigger.attr('aria-describedby', describedby);
        } else {
            // Rein visueller Tooltip -> keine tote ARIA-Referenz am Trigger stehen lassen
            removeDescribedbyRef($trigger, $tooltip.attr('id'));
            ensureTextAlternative($trigger, contentText, triggerText, triggerHidden, $source);
        }

        // Tooltip als eigener Layer direkt am <body>: kein overflow:hidden eines
        // Vorfahren kann ihn abschneiden, und es entsteht kein ungültiges HTML
        // (z.B. Block-Element in einem <span>-Wrapper).
        if ($tooltip.parent()[0] !== document.body) {
            $tooltip.appendTo(document.body);
        }

        var instance = new TooltipInstance($trigger, $tooltip, exposed);
        $trigger
            .data('simpletooltipInstance', instance)
            .data('simpletooltipInitialized', true);

        $trigger
            .off('.simpletooltip')
            .on('mouseenter.simpletooltip focusin.simpletooltip', function() {
                instance.show();
            })
            .on('mouseleave.simpletooltip focusout.simpletooltip', function() {
                instance.scheduleHide();
            });

        // Tooltip selbst hoverbar halten (1.4.13 Hoverable)
        $tooltip
            .off('.simpletooltip')
            .on('mouseenter.simpletooltip', function() {
                instance.cancelHide();
            })
            .on('mouseleave.simpletooltip', function() {
                instance.scheduleHide();
            });

        // Tap-Toggle nur für nicht-interaktive Trigger, sonst hätte es Vorrang vor Link/Button
        if (!focusable && !$trigger.closest('a, button').length) {
            $trigger.on('click.simpletooltip', function() {
                instance.toggle();
            });
        }

        bindDocumentHandlers();
    }

    // Aufruf-Kompatibilität: accessibleSimpleTooltipAria.apply(element) oder jQuery-Collection
    function accessibleSimpleTooltipAria() {
        var context = this;
        if (context && context.jquery) {
            return context.each(function() {
                initTooltip(this);
            });
        }
        initTooltip(context);
    }

    window.accessibleSimpleTooltipAria = accessibleSimpleTooltipAria;

    $.fn.accessibleSimpleTooltipAria = function() {
        return this.each(function() {
            initTooltip(this);
        });
    };

    $(document).ready(function() {
        $('.js-tooltip').each(function() {
            initTooltip(this);
        });
    });
})(jQuery);
